export class FeatureCore {
    name: string;
    short: string;
    code: string;
    link: string;
    section: string;
}

export interface Feature extends FeatureCore { // Feature interface extends FeatureCore class to allow to declare optional parameter 'consumer'
    consumer?: string;
}

export class Features {
    module: string;
    features: Feature[];
}